import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';

const Progress = styled.div<{ progressColor?: string }>`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  transform-style: preserve-3d;
  transform-origin: left;
  background-color: ${(p) => p.progressColor};
  border-radius: 2px;
  transition: transform 0.2s linear;
`;

const Bar = styled.div<{ bgColor?: string }>`
  position: relative;
  border-radius: 2px;
  overflow: hidden;
  transition: all 0.2s ease;
  background-color: ${(p) => p.bgColor};

  min-width: 20px;
  height: 3px;
`;

interface ProgressBarProps {
  progressColor?: string;
  bgColor?: string;
  percentage?: number;
}

export const ProgressBar = (props: ProgressBarProps) => {
  const { percentage = 0, bgColor = colorsV2.black20, progressColor = colorsV2.black80 } = props;

  return (
    <Bar bgColor={bgColor}>
      <Progress style={{ transform: `scaleX(${percentage})` }} progressColor={progressColor} />
    </Bar>
  );
};
